<template>
  <div class="common-icon-label" :class="[size]">
    <CommonIcon class="icon" :name="icon" :size="size == 'small' ? 16 : 24" :stroke-width="1.5" />
    <p><slot /></p>
  </div>
</template>

<script setup lang="ts">
import CommonIcon, { type Icons } from './CommonIcon.vue'

withDefaults(
  defineProps<{
    icon: Icons
    size?: 'small' | 'medium'
  }>(),
  {
    size: 'small'
  }
)
</script>

<style scoped>
.common-icon-label {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--vc-dark);
  font-weight: 400;
}

.small {
  font-size: 14px;
}

.medium > p {
  font-size: 16px;
  opacity: 75%;
}
</style>
